import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { Events } from "../../../utils/Events";
import { Pin } from "./Pin";
import { RouletteModel } from "./RouletteModel";
import { RouletteScene } from "../RouletteScene";
import { GameManager } from "../../../GameManager";

export class RouletteContainer extends Phaser.GameObjects.Container {

    public static angle = 0;

    private static readonly GOLD_GLOW_POSITIONS = [
        {x: -50, y: -544},
        {x: 140, y: -365},
        {x: -90, y: -245},
        {x: 38, y: -494},
        {x: 170, y: -472},
        {x: 46, y: 62},
        {x: -56, y: 62},
        {x: -56, y: -62},
    ];
    
    public rouletteModel: RouletteModel;
    public spinning: boolean;
    public rotatingItems: Phaser.GameObjects.Container;

    public f1: number;
    public f2: number;

    private pins: Pin [];
    private goldGlow: Phaser.GameObjects.Image;
    private a: number;
    private sector: Phaser.GameObjects.Image;
    private nail: Phaser.GameObjects.Image;
    private axis: Phaser.GameObjects.Image;
    private glowBehind: Phaser.GameObjects.Image;
    private wheel: Phaser.GameObjects.Image;
    private glow: Phaser.GameObjects.Image;
    private border: Phaser.GameObjects.Image;
    private showingPrize: boolean;
    private blurredRoulette: Phaser.GameObjects.Image;
    private borderGlow: Phaser.GameObjects.Sprite;

    private deltaAngle: number;
    private lastAngle: number;
    
    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.f1 = 0;
        this.f2 = 0;
        this.spinning = false;
        this.showingPrize = false;
        this.deltaAngle = 0;
        this.lastAngle = 0;

        this.rouletteModel = new RouletteModel();
        this.rouletteModel.a = RouletteContainer.angle;
        this.rouletteModel.addEventListener(Events.STOP_SPINNING, this.onStopSpinning, this);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;

        this.scaleY = GameVars.scaleY;

        this.glowBehind = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "glow-behind"); 
        this.glowBehind.setScale(3.1);
        this.glowBehind.alpha = .65;
        this.add(this.glowBehind)

        this.rotatingItems = new Phaser.GameObjects.Container(this.scene);
        this.rotatingItems.angle = RouletteContainer.angle;
        this.add(this.rotatingItems);

        this.wheel = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "roulette");
        this.wheel.setInteractive({pixelPerfect: true});
        this.wheel.on("pointerup", () => {
            this.onClickRoulette();
        }, this);
        this.rotatingItems.add(this.wheel);

        // los regalos
        this.addPrizes();

        this.border = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "roulette-border");
        this.add(this.border);

        this.glow = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "roulette-glow");
        this.glow.setScale(3);
        this.add(this.glow);

        this.pins = [];
        
        this.add(this.rotatingItems);

        for (let i = 0; i < 20; i++) {

            if(i === 16 || i  === 15 || i  === 14 ) {
                continue
            }

            const pin = new Pin(this.scene, this, i);
            this.add(pin);

            this.pins.push(pin);
        }

        this.sector = new Phaser.GameObjects.Image(this.scene, 0, -230, "texture_atlas_1", "sector");
        this.add(this.sector);

        this.borderGlow = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "texture_atlas_1");
        this.scene.add.existing(this.borderGlow);
        this.borderGlow.anims.play("border-glow");
        this.borderGlow.setScale(2);
        this.add(this.borderGlow);

        this.nail = new Phaser.GameObjects.Image(this.scene, 0, -510, "texture_atlas_1", "nail");
        this.add(this.nail);

        this.axis = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "axis");
        this.add(this.axis);

        this.goldGlow = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "gold_glare");
        this.goldGlow.visible = false;
        this.add(this.goldGlow);

        this.blurredRoulette = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "blurred-roulette");
        this.blurredRoulette.tint = 0xDDDDFF;
        this.blurredRoulette.visible = false;
        this.blurredRoulette.alpha = 0;
        this.blurredRoulette.setScale(2.8);

        this.add(this.blurredRoulette);
    }

    public update(): void {

        if (this.rouletteModel.spinning) {

            this.rouletteModel.update();

            this.deltaAngle += Math.abs(this.rouletteModel.getAngle() - this.lastAngle);

            if (this.deltaAngle >= 36) {

                this.deltaAngle = 0;

                this.scene.sound.playAudioSprite("audio-sprite", "tick");
            }

            this.rotatingItems.angle = this.rouletteModel.getAngle();
            this.lastAngle = this.rouletteModel.getAngle();
        } 

        for (let i = 0; i < this.pins.length; i++) {
            this.pins[i].update();
        }

        this.f1 ++;

        if (this.f1 === 80) {
            this.f1 = 0;
        }

        this.f2 ++;

        if (this.f2 === 150) {
            this.goldShine();
            this.f2 = 0;

            if (Math.random() > .5) {
                this.borderGlow.anims.play("border-glow");
            }
        }
    }

    public spin(): void {

        if (GameConstants.DEVELOPMENT && GameConstants.SKIP_ROTATION) {
            RouletteScene.currentInstance.rouletteManager.onRouletteStopped();
        } else {
            this.spinning = true;
            this.rouletteModel.spin();
        }
    }

    public stop(slowDownAngularSpeed: number): void {

        this.rouletteModel.stop(slowDownAngularSpeed)
    }

    public onPrizeShown(): void {

        this.showingPrize = true;

        RouletteContainer.angle = this.rotatingItems.angle;

        let scale: number;

        if (GameVars.aspectRatio < 1.65) {
            scale = .5;
        } else {
            scale = .75;
        }

        this.scene.add.tween({
            targets: this,
            scaleX: scale,
            scaleY: scale * GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 600
        });

        this.scene.add.tween({
            targets: [this.nail, this.axis, this.sector, this.wheel, this.glow, this.border, this.glowBehind, this.borderGlow],
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 600
        });

        this.blurredRoulette.visible = true;

        this.scene.add.tween({
            targets: this.blurredRoulette,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 600
        });

        for (let i = 0; i < this.pins.length; i++) {
            this.pins[i].onPrizeShown();
        }
    }

    private onStopSpinning(): void {

        let targetAngle: number;

        if (GameVars.i < 8)  {
            targetAngle = 36 * (8 - GameVars.i);
        } else {
            targetAngle = 36 * (18 - GameVars.i);
        }

        this.a = this.rouletteModel.getAngle();

        this.scene.add.tween({
            targets: this,
            a: targetAngle,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: Math.abs(targetAngle - this.a) * 500,
            onUpdate: function(): void  {
                this.rotatingItems.angle = this.a;
            },
            onUpdateScope: this,
            onComplete: function(): void {

                RouletteScene.currentInstance.rouletteManager.onRouletteStopped();
                this.spinning = false;

                this.scene.sound.playAudioSprite("audio-sprite", "tick");
            },
            onCompleteScope: this
        });
    }

    private goldShine(): void {

        if (this.showingPrize) {
            return;
        }

        const i = Math.floor(Math.random() * RouletteContainer.GOLD_GLOW_POSITIONS.length);

        this.goldGlow.x = RouletteContainer.GOLD_GLOW_POSITIONS[i].x;
        this.goldGlow.y = RouletteContainer.GOLD_GLOW_POSITIONS[i].y;

        this.goldGlow.visible = true;
        this.goldGlow.setScale(0);
        this.goldGlow.angle = 0;

        this.scene.add.tween({
            targets: this.goldGlow,
            scaleX: 5.5,
            scaleY: 5.5,
            angle: Math.random() > .5 ? -60 : 60,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 750,
            yoyo: true,
            onComplete: function(): void {
                this.goldGlow.visible = false;
            },
            onCompleteScope: this
        });
    }

    private onClickRoulette(): void {

        if (this.spinning || this.showingPrize) {
            return;
        }

        GameManager.enterPrizesScene();

        this.scene.sound.playAudioSprite("audio-sprite", "click_btn");
    }

    private addPrizes(): void {

        for (let i = 0; i < 10; i++) {
                
            const a = (i + .5) * Math.PI / 5;

            let x = 285 * Math.cos(a);
            let y = 285 * Math.sin(a);

            const prizeData = GameVars.prizeResults.prizes[i];

            let itemImg: Phaser.GameObjects.Image;
    
            if (prizeData.image) {
                itemImg= new Phaser.GameObjects.Image(this.scene, x, y, "prize-image-" + prizeData.id);
            } else {
                itemImg= new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", "box_small");
            }
            itemImg.rotation = a + Math.PI / 2;
            itemImg.setScale(160 / itemImg.width);
            this.rotatingItems.add(itemImg);

            let fontName = i % 2 ? "roboto-bold-white" : "roboto-bold-red";
            let name: string;

            if (prizeData.name.length < 20) {
                name = prizeData.name;
            } else {
                name = prizeData.name.substr(0, 20) +  "..";
            }

            if (prizeData.is_won) {

                x = 405 * Math.cos(a);
                y = 405 * Math.sin(a);
                
                const wonPrizeLabel = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", i % 2 ? "won-prize-label-white" : "won-prize-label-red");
                wonPrizeLabel.rotation = a + Math.PI / 2;
                this.rotatingItems.add(wonPrizeLabel);
            } else {

                x = 415 * Math.cos(a);
                y = 415 * Math.sin(a);

                const prizeNameLabel = new Phaser.GameObjects.BitmapText(this.scene, x, y, fontName, name, 27);
                prizeNameLabel.setOrigin(.5)
                prizeNameLabel.rotation = a + Math.PI / 2;
                prizeNameLabel.maxWidth = 200;
                prizeNameLabel.setCenterAlign();
                this.rotatingItems.add(prizeNameLabel);
            }

            if (GameConstants.DEVELOPMENT) {

                x = 150 * Math.cos(a);
                y = 150 * Math.sin(a);
                const indexLabel = new Phaser.GameObjects.Text(this.scene, x, y, prizeData.id.toString(), {fontFamily: "Arial", fontSize: "30px", color: "#000000"});
                indexLabel.rotation = a;
                indexLabel.setOrigin(.5);
                this.rotatingItems.add(indexLabel);
            } 
        }
    }
}
